<template>
  <div />
</template>

<script>

export default {
  name: 'VNPTChatbot',
  props: {
    appCode: {
      type: String,
      default: 'd1f4d3a0-8d18-11f0-a1db-55b881d31624',
    },
    appName: {
      type: Object,
      default: () => ({
        line1: 'Trường Chính trị cổng học viên',
        line2: 'Hỗ trợ 24/7',
      }),
    },
    primaryColor: {
      type: String,
      default: '#cb4b48',
    },
    botIcon: {
      type: String,
      default: 'https://hocvien.tctct.edu.vn/img/hgi-logo-truong-chinh-tri.c54e9997.png',
    },
    floatIcon: {
      type: String,
      default: 'https://hocvien.tctct.edu.vn/img/hgi-logo-truong-chinh-tri.c54e9997.png',
    },
    size: {
      type: String,
      default: 'medium', // small, medium, large
      validator: value => ['small', 'medium', 'large'].includes(value),
    },
  },

  data() {
    return {
      chatbotLoaded: false,
    }
  },

  computed: {
    chatbotStyles() {
      const sizes = {
        small: {
          floatWidth: '45',
          floatHeight: '45',
          headFontSize1: '16px',
          headFontSize2: '13px',
          chatFontSize: '10px',
        },
        medium: {
          floatWidth: '55',
          floatHeight: '55',
          headFontSize1: '18px',
          headFontSize2: '14px',
          chatFontSize: '11px',
        },
        large: {
          floatWidth: '62',
          floatHeight: '62',
          headFontSize1: '20px',
          headFontSize2: '16px',
          chatFontSize: '12px',
        },
      }
      return sizes[this.size]
    },
  },

  mounted() {
    this.initializeChatbot()
  },

  beforeUnmount() {
    this.destroyChatbot()
  },

  methods: {
    createUUID() {
      const sender = localStorage.getItem('sb_sender_name')
      let uuid = ''
      const dt = new Date().getTime()

      if (sender) {
        uuid = sender
      } else {
        uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
          const r = (dt + Math.random() * 16) % 16 | 0
          return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16)
        })

        try {
          localStorage.setItem('sb_sender_name', uuid)
        } catch (err) {
          console.log('LocalStorage error:', err)
        }
      }
      return uuid
    },

    initializeChatbot() {
      // Tránh load nhiều lần
      if (window.vnptChatbotLoaded) return

      const { protocol } = document.location
      const baseUrl = `${protocol}//livechat.vnpt.vn`
      const prefixNameLiveChat = ''

      // Cấu hình chatbot
      const objPreDefineLiveChat = {
        appCode: this.appCode,
        themes: '',
        appName: this.appName,
        thumb: '',
        icon_bot: this.botIcon,
        senderName: this.createUUID(),
        isTyping: true,
        timeTyping: 1000,
        isVoting: true,
        styles: {
          head: {
            bgColor: '#cb4b48',
            text: {
              line: 1,
              line1: {
                color: '#fff',
                fontSize: this.chatbotStyles.headFontSize1,
                fontWeight: 400,
              },
              line2: {
                color: '#fff',
                fontSize: this.chatbotStyles.headFontSize2,
                fontWeight: 400,
              },
            },
          },
          border: {},
          floatButton: {
            bgColor: '#fff',
            icon: this.floatIcon,
            width: this.chatbotStyles.floatWidth,
            height: this.chatbotStyles.floatHeight,
            img: {
              width: '51.6%', height: 'auto',
            },
          },
          chat: {
            bg: '#F3F6F6',
            button: {
              bg: '#cb4b48',
              color: '#fff',
            },
            answer: {
              bg: '#EEEEEE',
              color: '#545454',
              fontSize: this.chatbotStyles.chatFontSize,
            },
            question: {
              bg: '#cb4b48',
              color: '#fff',
              fontSize: this.chatbotStyles.chatFontSize,
            },
            botIcon: 'https://storage-smartbot.vnpt.vn/public-files/smartbot/logo_bot_default.svg',
          },
        },
      }

      // Check hash để override appCode nếu có
      const appCodeHash = window.location.hash.substr(1)
      if (appCodeHash.length === 32) {
        objPreDefineLiveChat.appCode = appCodeHash
      }

      this.loadChatbotResources(baseUrl, objPreDefineLiveChat)
    },

    loadChatbotResources(baseUrl, config) {
      // Kiểm tra xem script đã được tải chưa
      if (document.getElementById('vnpt_ai_livechat_script')) {
        this.renderChatbot(config, baseUrl)
        return
      }

      // Tải CSS
      const stylesheet = document.createElement('link')
      stylesheet.id = 'vnpt_ai_livechat_stylesheet'
      stylesheet.rel = 'stylesheet'
      stylesheet.href = `${baseUrl}/vnpt_smartbot_stream_ver2.css`
      document.head.appendChild(stylesheet)

      // Tải JavaScript
      const script = document.createElement('script')
      script.id = 'vnpt_ai_livechat_script'
      script.src = `${baseUrl}/vnpt_smartbot_stream_ver2.js`

      script.onload = () => {
        this.chatbotLoaded = true
        this.renderChatbot(config, baseUrl)
        window.vnptChatbotLoaded = true
      }

      script.onerror = () => {
        console.error('Failed to load VNPT chatbot script')
      }

      document.body.appendChild(script)
    },

    renderChatbot(config, baseUrl) {
      if (typeof window.vnpt_ai_render_chatbox === 'function') {
        window.vnpt_ai_render_chatbox(config, baseUrl, 'livechat.vnpt.ai:443')
        this.$emit('chatbot-loaded', config)
      }
    },

    destroyChatbot() {
      // Cleanup khi component bị destroy
      const script = document.getElementById('vnpt_ai_livechat_script')
      const stylesheet = document.getElementById('vnpt_ai_livechat_stylesheet')

      if (script) script.remove()
      if (stylesheet) stylesheet.remove()

      window.vnptChatbotLoaded = false
      this.$emit('chatbot-destroyed')
    },

    // Public methods để control chatbot từ bên ngoài
    show() {
      // Logic để hiện chatbot nếu API hỗ trợ
      if (window.vnpt_ai_show_chatbox) {
        window.vnpt_ai_show_chatbox()
      }
    },

    hide() {
      // Logic để ẩn chatbot nếu API hỗ trợ
      if (window.vnpt_ai_hide_chatbox) {
        window.vnpt_ai_hide_chatbox()
      }
    },
  },
}
</script>
